import React, { useState, useRef, useEffect, useCallback } from 'react';
import { X, Search, ChevronLeft, ChevronRight } from 'lucide-react';
import Pagination from '../../components/Pagination';
import apiHelper from '../../apiHelper';
import Tooltip from '../addentities/Tooltip';
import noImage from '../../assets/img/brand/noImage.png'


const mapApiToFrontend = (apiData) => {
    return apiData.map((item) => ({
        id: `${item?.stock_instance_id}_${item?.branch_details?.[0]?.branch_id ?? 0}`,
        stockInstanceId: item?.stock_instance_id,
        image: item?.sku_image || item?.image || noImage,
        name: item?.spu_name || 'N/A',
        variant: item?.sku_name || 'N/A',
        model_number: item?.model_number || '',
        condition: item.condition || 'N/A',
        grade: item.condition_type || 'N/A',
        serialNo: item.barcode_imei || 'N/A',
        branch: item.branch_details?.length > 0 ? item.branch_details[0].branch_name : 'N/A',
        branchId: item.branch_details?.length > 0 ? item.branch_details[0].branch_id : null,
        costPrice: parseFloat(item.cost_price || 0),
        currency: item.currency_id || 'SGD',
        sellableQty: item.sellable_qty || 0,
        lastStock: item.created_at
            ? (() => {
                const d = new Date(new Date(item.created_at).toLocaleString('en-US', { timeZone: 'Asia/Singapore' }));
                const yyyy = d.getFullYear();
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const hh = String(d.getHours()).padStart(2, '0');
                const min = String(d.getMinutes()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}  ${hh}:${min}`;
              })()
            : '',

        linkedQty: 0,
    }));
};

const PAGE_SIZE = 8;

// ── FilterIcon ────────────────────────────────────────────────────────────────
const FilterIcon = ({ active }) =>
    active ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <g clipPath="url(#a)"><path d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 8.55813 19.726 8.55813 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z" fill="#0D6EFD" /></g>
            <defs><clipPath id="a"><rect width="12" height="12" fill="white" transform="translate(11 5)" /></clipPath></defs>
        </svg>
    ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

// ── BranchTag ─────────────────────────────────────────────────────────────────
const BranchTag = ({ label, onRemove }) => (
    <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: '#FFEB00', borderRadius: 99,
        padding: '3px 10px', fontSize: 13, fontWeight: 600,
        color: '#212529', whiteSpace: 'nowrap',
    }}>
        {label}
        <button
            type="button"
            onClick={() => onRemove(label)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', color: '#212529' }}
        >
            <X size={12} strokeWidth={2.5} />
        </button>
    </span>
);

// ── LinkedQtyInput ────────────────────────────────────────────────────────────
const LinkedQtyInput = ({ value, max, onChange, selected }) => {
    const [inputVal, setInputVal] = useState(String(value));

    // sync when value changes externally (e.g. checkbox toggle)
    useEffect(() => {
        setInputVal(String(value));
    }, [value]);

    const commit = (num) => {
        const clamped = Math.min(Math.max(1, num), max);
        setInputVal(String(clamped));
        onChange(clamped);
    };

    const handleChange = (e) => {
        const raw = e.target.value;
        if (/^\d*$/.test(raw)) setInputVal(raw);
    };

    const handleBlur = () => {
        const num = parseInt(inputVal, 10);
        if (isNaN(num) || num < 1) {
            const fallback = value > 0 ? 1 : 0;
            setInputVal(String(fallback));
            onChange(fallback);
        } else {
            commit(num);
        }
    };

    const increment = (e) => {
        e.stopPropagation();
        const current = parseInt(inputVal, 10) || 0;
        commit(current + 1);
    };

    const decrement = (e) => {
        e.stopPropagation();
        const current = parseInt(inputVal, 10) || 1;
        commit(current - 1);
    };

    return (
        <div
            style={{
                display: 'flex', alignItems: 'center',
                height: '35px',
                padding: '10px 0 10px 10px',
                borderRadius: '8px',
                border: selected ? '1px solid #6C757D' : '1px solid #CED4DA',
                background: selected ? '#FFF' : '#E9ECEF',
                overflow: 'hidden', width: 100,
            }}
            onClick={e => e.stopPropagation()}
        >
            {/* Direct number input */}
            <input
                type="text"
                inputMode="numeric"
                value={inputVal}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                    flex: 1, border: 'none', outline: 'none',
                    padding: '0 10px 0 0', fontSize: 14,
                    color: '#6C757D', textAlign: 'center',
                    fontFamily: 'Montserrat', fontWeight: 400,
                    lineHeight: '18px', background: 'transparent',
                    minWidth: 0,
                }}
            />

            {/* Up / Down buttons */}
            <div style={{
                display: 'flex', flexDirection: 'column',
                 width: 24, flexShrink: 0,
           
            }}>
                {/* Up */}
                <button
                    type="button"
                    onClick={increment}
                    // disabled={parseInt(inputVal, 10) >= max}
                    style={{
                        flex: 1, border: 'none', background: 'transparent',
                        // cursor: parseInt(inputVal, 10) >= max ? 'not-allowed' : 'pointer',
                        padding: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        lineHeight: 0,
                        // opacity: parseInt(inputVal, 10) >= max ? 0.4 : 1,
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 10L8 6L4 10" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                {/* Down */}
                <button
                    type="button"
                    onClick={decrement}
                    // disabled={parseInt(inputVal, 10) <= 1}
                    style={{
                        flex: 1, border: 'none', background: 'transparent',
                        // cursor: parseInt(inputVal, 10) <= 1 ? 'not-allowed' : 'pointer',
                        padding: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        lineHeight: 0,
                        // opacity: parseInt(inputVal, 10) <= 1 ? 0.4 : 1,
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M4 6L8 10L12 6" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};

// ── Main Modal ────────────────────────────────────────────────────────────────
export default function LinkStockInstancesModal({ isOpen, onClose, onConfirm, preSelected = [] }) {
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterOpen, setFilterOpen] = useState(false);
    const filterRef = useRef(null);
    const [tempBranches, setTempBranches] = useState([]);
    const [tempCostMin, setTempCostMin] = useState('');
    const [tempCostMax, setTempCostMax] = useState('');
    const [costMinFocused, setCostMinFocused] = useState(false);
    const [costMaxFocused, setCostMaxFocused] = useState(false);

    const formatCostDisplay = (val) => {
        if (val === '' || val == null) return '';
        const num = parseFloat(String(val).replace(/,/g, ''));
        if (isNaN(num)) return val;
        return num.toLocaleString('en-SG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    const [appliedBranches, setAppliedBranches] = useState([]);
    const [appliedCostMin, setAppliedCostMin] = useState('');
    const [appliedCostMax, setAppliedCostMax] = useState('');
    const [branchDropdownOpen, setBranchDropdownOpen] = useState(false);
    const [branchSearchInput, setBranchSearchInput] = useState('');
    const branchDropdownRef = useRef(null);
    const [stockInstances, setStockInstances] = useState([]);
    const [branchOptions, setBranchOptions] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [isPending, setIsPending] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const isPageResetRef = useRef(false);
    const currentPageRef = useRef(1);
    const sortFieldRef = useRef(null);
    const sortOrderRef = useRef(null);
    const selectedItemsCacheRef = useRef({});
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [linkedQtys, setLinkedQtys] = useState({});
    const [searchType, setSearchType] = useState('stock');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [lsiColWidths, setLsiColWidths] = useState({
        stock: 210,
        serialNo: 300,
        branch: 120,
        costPrice: 130,
        sellableQty: 100,
        lastStock: 150,
    });

    const handleLsiColResizeMouseDown = (e, key, startWidth, minWidth = 80) => {
        e.preventDefault();
        e.stopPropagation();
        const startX = e.clientX;
        const onMouseMove = (moveEvent) => {
            const delta = moveEvent.clientX - startX;
            setLsiColWidths((prev) => ({ ...prev, [key]: Math.max(minWidth, startWidth + delta) }));
        };
        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const LsiColResizeHandle = ({ colKey, minWidth }) => (
        <div
            className="col-resize-handle"
            onMouseDown={(e) => handleLsiColResizeMouseDown(e, colKey, lsiColWidths[colKey], minWidth)}
            onClick={(e) => e.stopPropagation()}
            style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', zIndex: 2, userSelect: 'none' }}
        />
    );

    // The Stock column sits right next to the sticky Select column (left:90px
    // vs left:0), and fractional widths can leave a subpixel hairline between
    // the two, letting the scrolling content underneath show through. This
    // strip extends the Stock cell's own background 1px past its left edge
    // to cover that sliver — Stock is given a higher z-index than Select
    // (above) so this cover reliably paints over the seam.
    const stockEdgeCover = (
        <div
            aria-hidden="true"
            style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '-1px',
                width: '2px',
                background: 'inherit',
                pointerEvents: 'none',
            }}
        />
    );

    const lsiTableScrollRef = useRef(null);
    const [lsiScrolledLeft, setLsiScrolledLeft] = useState(false);
    const [lsiScrolledRight, setLsiScrolledRight] = useState(false);
    const handleLsiTableScroll = () => {
        const el = lsiTableScrollRef.current;
        if (!el) return;
        setLsiScrolledLeft(el.scrollLeft > 0);
        setLsiScrolledRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    useEffect(() => {
        if (!dropdownOpen) return;
        const handleOutsideClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [dropdownOpen]);

    // ── seed selections from preSelected when modal opens ──
    useEffect(() => {
        if (isOpen && preSelected.length > 0) {
            const seeded = {};
            preSelected.forEach(item => {
                if (item.id != null) {
                    seeded[item.id] = item.qty || 1;
                    // cache full data so handleConfirm can always find it
                    selectedItemsCacheRef.current[item.id] = item;
                }
            });
            setLinkedQtys(seeded);
        } else if (!isOpen) {
            setLinkedQtys({});
        }
    }, [isOpen]);

    // ── close filter on outside click ──
    useEffect(() => {
        if (!filterOpen) return;
        const handler = (e) => {
            if (filterRef.current && !filterRef.current.contains(e.target)) {
                setFilterOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [filterOpen]);

    useEffect(() => {
        if (!branchDropdownOpen) {
            setBranchSearchInput('');
            return;
        }
        const handler = (e) => {
            if (branchDropdownRef.current && !branchDropdownRef.current.contains(e.target)) {
                setBranchDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [branchDropdownOpen]);

    const SORT_FIELD_MAP = {
        name:        'spu_name',
        serialNo:    'barcode_imei',
        branch:      'branch_name',
        costPrice:   'cost_price',
        sellableQty: 'sellable_qty',
        lastStock:   'created_at',
    };

    const fetchInstances = useCallback(async ({ search, type, branches, costMin, costMax, page = 1, sort, order, currentPreSelected = [] }) => {
        setIsFetching(true);
        setFetchError(null);
        try {
            const params = new URLSearchParams();
            if (search) {
                if (type === 'imei') params.set('barcode_imei', search);
                else params.set('search', search);
            }
            // When searching by IMEI the backend can't handle branch param simultaneously — filter client-side instead
            if (branches?.length && !(type === 'imei' && search)) params.set('branch', branches.join(','));
            if (costMin !== '') params.set('cost_price_min', costMin);
            if (costMax !== '') params.set('cost_price_max', costMax);
            if (sort && SORT_FIELD_MAP[sort]) {
                const backendField = SORT_FIELD_MAP[sort];
                params.set('ordering', order === 'desc' ? `-${backendField}` : backendField);
            }
            const preselectedIds = [...new Set(currentPreSelected.map(p => p.stockInstanceId).filter(Boolean))];
            if (preselectedIds.length) params.set('preselected_ids', preselectedIds.join(','));
            params.set('page', page);
            params.set('page_size', PAGE_SIZE);

            const res = await apiHelper(`sales/stock-instances/?${params.toString()}`, 'GET');
            if (res.ok) {
                const json = await res.json();
                // Support both paginated {count, results} and plain array responses
                const items = Array.isArray(json) ? json : (json.results ?? []);
                const count = Array.isArray(json) ? json.length : (json.count ?? json.length ?? 0);
                const mapped = mapApiToFrontend(items).map(row => {
                    const pre = currentPreSelected.find(p =>
                        String(p.stockInstanceId) === String(row.stockInstanceId) ||
                        String(p.id) === String(row.stockInstanceId)
                    );
                    if (pre) return { ...row, sellableQty: row.sellableQty + (pre.qty || 1) };
                    return row;
                }).filter(row => {
                    const isLinked = currentPreSelected.some(p =>
                        String(p.stockInstanceId) === String(row.stockInstanceId) ||
                        String(p.id) === String(row.stockInstanceId)
                    );
                    return isLinked || row.sellableQty > 0;
                });
                const filteredOut = items.length - mapped.length;

                // Re-rank by match quality when searching by name so exact matches surface first
                // Only apply when no explicit column sort is active — otherwise the column sort takes priority
                let displayItems = mapped;
                if (search && type !== 'imei' && !sort) {
                    // Collapse runs of whitespace so "iPhone  15" ranks like "iPhone 15" —
                    // must stay in step with the backend's _relevance annotation.
                    const q = search.trim().replace(/\s+/g, ' ').toLowerCase();
                    const rank = (row) => {
                        const n = (row.name || '').toLowerCase();
                        if (n === q) return 0;
                        if (n.startsWith(q)) return 1;
                        if (n.includes(q)) return 2;
                        return 3;
                    };
                    // Within a rank the shorter name is the closer match, mirroring the
                    // backend's _name_len tie-break.
                    displayItems = [...mapped].sort((a, b) =>
                        rank(a) - rank(b) || (a.name || '').length - (b.name || '').length
                    );
                }

                setStockInstances(displayItems);
                setTotalCount(Math.max(0, count - filteredOut));

                // Reconcile preSelected keys (link IDs / _order_ format) → stable stockInstanceId_branchId keys
                setLinkedQtys(prev => {
                    const updated = { ...prev };
                    let changed = false;
                    const usedSourceKeys = new Set(
                        mapped.filter(r => updated[r.id] != null).map(r => r.id)
                    );
                    mapped.forEach(row => {
                        if (updated[row.id] != null) return; // stable ID already matches
                        // Only remap preSelected source keys (link IDs or _order_ format).
                        // Skip keys already in stockInstanceId_branchId format — they are stable
                        // and never need remapping.
                        const sourceKey = Object.keys(updated).find(k => {
                            if (usedSourceKeys.has(k)) return false;
                            if (/^\d+_\d+$/.test(String(k))) return false; // stable ID, skip
                            if (String(k) === String(row.stockInstanceId)) return true;
                            const pre = currentPreSelected.find(p => String(p.id) === k);
                            return pre != null && String(pre.stockInstanceId) === String(row.stockInstanceId);
                        });
                        if (sourceKey != null) {
                            updated[row.id] = updated[sourceKey];
                            delete updated[sourceKey];
                            selectedItemsCacheRef.current[row.id] = row;
                            usedSourceKeys.add(sourceKey);
                            changed = true;
                        }
                    });
                    return changed ? updated : prev;
                });
                setBranchOptions(prev => {
                    const newBranches = items.flatMap(item =>
                        item.branch_details?.map(b => b.branch_name) || []
                    );
                    return [...new Set([...prev, ...newBranches])];
                });
            } else {
                const bodyText = await res.text().catch(() => '');
                console.error(`Error fetching stock instances: ${res.status} ${res.statusText}`, bodyText);
                setStockInstances([]);
                setTotalCount(0);
                setFetchError('Something went wrong while loading results. Please try again.');
            }
        } catch (error) {
            console.error("Error fetching stock instances:", error);
            setStockInstances([]);
            setTotalCount(0);
            setFetchError('Something went wrong while loading results. Please try again.');
        } finally {
            setIsFetching(false);
            setIsPending(false);
        }
    }, []);

    // fetch all branches when modal opens; reset search/filter/sort/page when modal closes
    useEffect(() => {
        if (!isOpen) {
            setStockInstances([]);
            setBranchOptions([]);
            setSearchInput('');
            setSearchTerm('');
            setAppliedBranches([]);
            setAppliedCostMin('');
            setAppliedCostMax('');
            setTempBranches([]);
            setTempCostMin('');
            setTempCostMax('');
            setCurrentPage(1);
            // Back to no sort, matching the initial state. Seeding a sort here meant every
            // reopen sent ordering=created_at, which makes the backend skip its relevance
            // ranking so exact search matches no longer come first.
            setSortField(null);
            setSortOrder(null);
            setSearchType('stock');
            return;
        }
        apiHelper('entities/branches/?archived=false', 'GET')
            .then(res => res.ok ? res.json() : [])
            .then(data => {
                const names = (Array.isArray(data) ? data : (data.results ?? []))
                    .map(b => b.branch_name)
                    .filter(Boolean);
                setBranchOptions(names);
            })
            .catch(() => {});
    }, [isOpen]);

    // Keep refs in sync — used inside Effect 1's debounce timer to avoid stale closures
    currentPageRef.current = currentPage;
    sortFieldRef.current = sortField;
    sortOrderRef.current = sortOrder;

    // Effect 1: search/filter changes → reset to page 1 and fetch page 1
    useEffect(() => {
        if (!isOpen) return;

        const hasQuery = searchTerm.trim() !== '' || appliedBranches.length > 0 || appliedCostMin !== '' || appliedCostMax !== '';
        if (!hasQuery) {
            setStockInstances([]);
            setTotalCount(0);
            return;
        }

        setIsPending(true);
        const timer = setTimeout(() => {
            // Only flag a reset if page actually needs to change — if already on page 1,
            // setCurrentPage(1) is a React no-op so Effect 2 never fires to clear the flag,
            // leaving isPageResetRef stuck at true and causing the next page navigation to skip its fetch.
            if (currentPageRef.current !== 1) {
                isPageResetRef.current = true;
            }
            setCurrentPage(1);
            fetchInstances({ search: searchTerm, type: searchType, branches: appliedBranches, costMin: appliedCostMin, costMax: appliedCostMax, page: 1, sort: sortFieldRef.current, order: sortOrderRef.current, currentPreSelected: preSelected });
        }, searchTerm !== '' ? 400 : 0);
        return () => clearTimeout(timer);
    }, [isOpen, searchTerm, searchType, appliedBranches, appliedCostMin, appliedCostMax]);

    // Effect 2: page or sort change → fetch (skip if it was a page-1 reset from Effect 1)
    useEffect(() => {
        if (!isOpen) return;
        if (isPageResetRef.current) {
            isPageResetRef.current = false;
            return;
        }
        const hasQuery = searchTerm.trim() !== '' || appliedBranches.length > 0 || appliedCostMin !== '' || appliedCostMax !== '';
        if (!hasQuery) return;
        fetchInstances({ search: searchTerm, type: searchType, branches: appliedBranches, costMin: appliedCostMin, costMax: appliedCostMax, page: currentPage, sort: sortField, order: sortOrder, currentPreSelected: preSelected });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, sortField, sortOrder]);

    const filtered = appliedBranches.length > 0
        ? stockInstances.filter(item => appliedBranches.some(b => b.trim() === item.branch?.trim()))
        : stockInstances;

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(prev => (prev === 'asc' || prev === null) ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortOrder('asc');
        }
    };

    // A new search is a new intent, so drop any column sort left over from the previous
    // one — otherwise the backend takes its column-sort branch and skips the relevance
    // ranking, so exact matches no longer come first. The sorted column can also be
    // scrolled out of view behind the sticky Linked Qty column, leaving no visual cue
    // that a sort is still active.
    const clearSortForNewSearch = (nextTerm) => {
        if (sortFieldRef.current === null && sortOrderRef.current === null) return;
        // Effect 1 re-fetches when searchTerm changes; let it do the work rather than
        // having Effect 2 fire a duplicate request for the sort change.
        if (nextTerm !== searchTerm) isPageResetRef.current = true;
        setSortField(null);
        setSortOrder(null);
    };

    const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
    const safePage = Math.min(currentPage, totalPages);
    const pageData = filtered;

    useEffect(() => {
        handleLsiTableScroll();
    }, [pageData]);

    const filtersApplied = appliedBranches.length > 0 || appliedCostMin !== '' || appliedCostMax !== '';
    const hasQuery = searchTerm.trim() !== '' || filtersApplied;

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            clearSortForNewSearch(searchInput);
            setSearchTerm(searchInput);
            setCurrentPage(1);
        }
    };

    const branchesFromApi = [...branchOptions].sort((a, b) => a.localeCompare(b));

    const openFilter = () => {
        setTempBranches([...appliedBranches]);
        setTempCostMin(appliedCostMin);
        setTempCostMax(appliedCostMax);
        setFilterOpen(true);
    };

    const handleFilterConfirm = () => {
        setAppliedBranches([...tempBranches]);
        setAppliedCostMin(tempCostMin);
        setAppliedCostMax(tempCostMax);
        setCurrentPage(1);
        setFilterOpen(false);
    };

    const handleFilterClear = () => {
        setTempBranches([]);
        setTempCostMin('');
        setTempCostMax('');
    };


    const handleCancel = () => {
        setLinkedQtys({});
        selectedItemsCacheRef.current = {};
        onClose();
    };

    const handleConfirm = () => {
        const selected = Object.entries(linkedQtys)
            .filter(([, qty]) => qty > 0)
            .map(([id, qty]) => {
                const fullData = stockInstances.find(item => item.id === id)
                    ?? selectedItemsCacheRef.current[id]
                    ?? preSelected.find(item => item.id === id);

                return {
                    ...fullData,
                    qty,
                };
            });

        console.log("Selected Full Data:", selected);

        onConfirm && onConfirm(selected);
    };

    if (!isOpen) return null;

    const EmptyState = () => {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "clamp(200px, 60vh, 480px)",
                    padding: "40px 20px",
                    textAlign: "center",
                    color: "#6C757D",
                }}
            >
                {/* SVG */}
                <svg xmlns="http://www.w3.org/2000/svg" width="190" height="129" viewBox="0 0 190 129" fill="none">
                    <path d="M130.821 16.5793V121.777C130.821 124.051 129.048 125.892 126.859 125.892H47.5694C45.3802 125.892 43.6074 124.051 43.6074 121.781C43.6074 105.528 43.6074 47.667 43.6074 48.9578V7.22247C43.6074 4.94924 45.3802 3.1084 47.5694 3.1084H115.894C116.546 3.1084 117.18 3.34685 117.679 3.7856L129.871 14.4587C130.475 14.9864 130.821 15.7622 130.821 16.5793Z" fill="#FAF28C" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                    <path d="M52.9004 29.2236H97.6829" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 39.6802H89.1993" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 50.1372H89.1993" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 60.3618H114.136" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 70.5903H114.136" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 80.8149H114.136" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 91.0425H105.867" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M52.9004 101.268H123.957" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M67.3985 46.6265H10.4723C8.12961 46.6265 6.23047 48.5076 6.23047 50.828V51.6088C6.23047 53.9293 8.12961 55.8104 10.4723 55.8104H67.3985C69.7412 55.8104 71.6403 53.9293 71.6403 51.6088V50.828C71.6403 48.5076 69.7412 46.6265 67.3985 46.6265Z" fill="#F9ED32" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                    <path d="M33.7205 115.846V86.8113L10.4727 55.8105H67.3988L45.9743 86.8113V106.988L33.7205 115.846Z" fill="#F9ED32" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                    <path d="M142.322 71.8013L137.131 76.397L140.499 80.1296L145.69 75.5339L142.322 71.8013Z" fill="#F9ED32" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                    <path d="M146.801 74.2598L139.098 81.0796L160.918 105.261L168.621 98.4414L146.801 74.2598Z" fill="#F9ED32" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                    <path d="M120.625 81.8017C136.497 81.8017 149.364 69.0566 149.364 53.3347C149.364 37.6128 136.497 24.8677 120.625 24.8677C104.752 24.8677 91.8848 37.6128 91.8848 53.3347C91.8848 69.0566 104.752 81.8017 120.625 81.8017Z" fill="#F9ED32" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                    <path d="M120.398 75.75C133.299 75.75 143.758 65.6602 143.758 53.2139C143.758 40.7675 133.299 30.6777 120.398 30.6777C107.496 30.6777 97.0371 40.7675 97.0371 53.2139C97.0371 65.6602 107.496 75.75 120.398 75.75Z" fill="#FAF28C" stroke="#231F20" stroke-width="2" stroke-miterlimit="10" />
                </svg>

                {/* Heading */}
                <span style={{ margin: "10px", gap: 10, color: "#212529", fontSize: 20, fontWeight: 600, textAlign: "center", fontStyle: "normal", lineHeight: "normal" }}>
                    Search or Filter to Start
                </span>

                {/* Subtext */}
                <p style={{ margin: 0, color: "#6C757D", fontSize: 14, fontWeight: 400, lineHeight: "18px" }}>
                    Data will load after you search or filter.
                </p>
            </div>
        );
    };

    return (
        <>
            <div
                style={{
                    position: 'fixed', inset: 0,
                    background: 'rgba(0,0,0,0.45)',
                    zIndex: 1040,
                }}
                onClick={onClose}
            />

            {/* Modal */}
            <div
                style={{
                    position: 'fixed',
                    top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'min(1080px, 96vw)',
                    height: 'min(90vh, 860px)',
                    maxHeight: '90vh',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
                    zIndex: 1050,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    fontFamily: 'Montserrat, sans-serif',
                }}
                onClick={e => e.stopPropagation()}
            >
                {/* ── Header ── */}
                <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '20px 24px 12px',
                    flexShrink: 0,
                }}>
                    <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#212529' }}>
                        Select StockInstance
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            padding: 4, display: 'flex', alignItems: 'center', color: '#212529',
                        }}
                    >
                        <X size={22} strokeWidth={2} />
                    </button>
                </div>

                {/* ── Toolbar ── */}
                <div style={{ padding: '0 24px 12px', display: 'flex', gap: 10, alignItems: 'center', flexShrink: 0 }}>
                    {/* Search */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #6C757D',
                            borderRadius: 8,
                            height: 40,
                            minWidth: '500px',
                            background: '#fff',
                            overflow: 'visible',
                            position: 'relative',
                        }}
                    >
                        {/* Dropdown */}
                        <div ref={dropdownRef} style={{ position: 'relative' }}>
                            <div
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                                style={{
                                    padding: '10px',
                                    height: '40px',
                                    width: '90px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    borderRight: '1px solid #6C757D',
                                    borderTopBottom: '1px solid #6C757D',
                                    fontSize: 14,
                                    fontFamily: 'Montserrat',
                                    color: '#212529',
                                }}
                            >
                                <span style={{ marginRight: 12, }}>{searchType === 'stock' ? 'Stock' : 'IMEI'}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ transition: 'transform 0.2s', transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                    <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>

                            {dropdownOpen && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        background: '#fff',
                                        border: '1px solid #CED4DA',
                                        borderRadius: 6,
                                        marginTop: 4,
                                        width: '100%',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                        zIndex: 10,
                                        color: '#212529',
                                    }}
                                >
                                    {['stock', 'imei'].map((item) => (
                                        <div
                                            key={item}
                                            onClick={() => {
                                                if (item !== searchType) {
                                                    clearSortForNewSearch('');
                                                    setSearchType(item);
                                                    setSearchInput('');
                                                    setSearchTerm('');
                                                }
                                                setDropdownOpen(false);
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                fontSize: "14px",
                                                background:
                                                    searchType === item ? '#FFFEF0' : 'transparent',
                                            }}
                                        >
                                            {item === 'stock' ? 'Stock' : 'IMEI'}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search Icon */}
                        {/* <div style={{ padding: '0 8px', display: 'flex', alignItems: 'center' }}>
                            <Search size={16} color="#6C757D" />
                        </div> */}

                        {/* Input */}
                        <input
                            type="text"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            onKeyDown={handleSearchKeyDown}
                            style={{
                                border: 'none',
                                outline: 'none',
                                flex: 1,
                                fontSize: 14,
                                fontFamily: 'Montserrat',
                                background: 'transparent',
                                color: '#212529',
                                padding: '10px'
                            }}
                        />
                        {searchTerm && (
                            <div
                                onClick={() => {
                                    clearSortForNewSearch('');
                                    setSearchInput('');
                                    setSearchTerm('');
                                    setCurrentPage(1);
                                }}
                                style={{ padding: '0 10px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9 3L3 9M3 3L9 9" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        )}
                    </div>

                    {/* Filter button + dropdown */}
                    <div style={{ position: 'relative' }} ref={filterRef}>
                        <button
                            type="button"
                            onClick={openFilter}
                            style={{
                                width: 40, height: 40, border: `1px solid ${filtersApplied ? '#0D6EFD' : '#6C757D'}`,
                                borderRadius: 8, background: filtersApplied ? '#CFE2FF' : '#fff',
                                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}
                        >
                            <FilterIcon active={filtersApplied} />
                        </button>

                        {/* Filter Dropdown */}
                        {filterOpen && (
                            <div style={{
                                position: 'absolute', top: 44, left: '50%', transform: 'translateX(-50%)', zIndex: 200,
                                background: '#fff', borderRadius: 10,
                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                padding: '20px 20px 16px',
                                width: 380,
                                fontFamily: 'Montserrat',
                            }}>
                                {/* Branch */}
                                <div style={{ marginBottom: 18 }}>
                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#212529', marginBottom: 8 }}>Branch</div>

                                    {/* Trigger box: tags + search input + chevron */}
                                    <div
                                        ref={branchDropdownRef}
                                        style={{ position: 'relative' }}
                                    >
                                        <div
                                            style={{
                                                border: '1px solid #6C757D', borderRadius: 8,
                                                padding: '6px 10px', minHeight: 40,
                                                display: 'flex', flexWrap: 'wrap', gap: 6,
                                                alignItems: 'center', background: '#fff',
                                                cursor: 'text', minWidth: "260px", alignContent: 'center', alignSelf: 'center'
                                            }}
                                            onClick={() => setBranchDropdownOpen(true)}
                                        >
                                            {/* Tags + search input — wraps freely */}
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, flex: 1, alignItems: 'center' }}>
                                                {tempBranches.map(b => (
                                                    <BranchTag key={b} label={b} onRemove={(br) => {
                                                        setTempBranches(prev => prev.filter(x => x !== br));
                                                    }} />
                                                ))}
                                                <input
                                                    type="text"
                                                    value={branchSearchInput}
                                                    onChange={e => { setBranchSearchInput(e.target.value); setBranchDropdownOpen(true); }}
                                                    placeholder={tempBranches.length === 0 ? 'Select or Search...' : ''}
                                                    style={{
                                                        border: 'none', outline: 'none', flex: 1, minWidth: 80,
                                                        fontSize: 14, fontFamily: 'Montserrat',
                                                        background: 'transparent', color: '#212529',
                                                        padding: '2px 0',
                                                    }}
                                                />
                                            </div>
                                            {/* Icons — always pinned to the right */}
                                            <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'flex-start', paddingTop: 9, gap: 2, flexShrink: 0 }}>
                                                {tempBranches.length > 0 && (
                                                    <button
                                                        type="button"
                                                        onClick={e => { e.stopPropagation(); setTempBranches([]); setBranchSearchInput(''); }}
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                            <path d="M9 3L3 9M3 3L9 9" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    onClick={e => { e.stopPropagation(); setBranchDropdownOpen(v => !v); }}
                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', display: 'flex', alignItems: 'center' }}
                                                >
                                                    {branchDropdownOpen
                                                        ? <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11 9L7 5L3 9" stroke="#6C757D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                        : <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 5L7 9L11 5" stroke="#6C757D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                    }
                                                </button>
                                            </div>
                                        </div>

                                        {/* Branch list dropdown */}
                                        {branchDropdownOpen && (
                                            <div
                                                style={{
                                                    position: 'absolute', top: '100%', left: 0, right: 0,
                                                    background: '#fff', border: '1px solid #CED4DA',
                                                    borderRadius: 8, zIndex: 300, marginTop: 4,
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                    maxHeight: 200, overflowY: 'auto',
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                {(() => {
                                                    const filtered = branchesFromApi.filter(b => b.toLowerCase().includes(branchSearchInput?.toLowerCase()));
                                                    if (filtered.length === 0) {
                                                        return (
                                                            <div style={{ padding: '12px 14px', fontSize: 13, color: '#ADB5BD', textAlign: 'center' }}>
                                                                No results found
                                                            </div>
                                                        );
                                                    }
                                                    return filtered.map(b => {
                                                        const isSelected = tempBranches?.includes(b);
                                                        return (
                                                            <div
                                                                key={b}
                                                                onClick={() => {
                                                                    if (isSelected) setTempBranches(p => p.filter(x => x !== b));
                                                                    else setTempBranches(p => [...p, b]);
                                                                    setBranchSearchInput('');
                                                                }}
                                                                style={{
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                    padding: '9px 14px', cursor: 'pointer',
                                                                    fontSize: 13, color: '#212529',
                                                                    background: isSelected ? '#FFFEF0' : '#fff',
                                                                }}
                                                            >
                                                                <span>{b}</span>
                                                                {isSelected && (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M3 8L6.5 11.5L13 4.5" stroke="#212529" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        );
                                                    });
                                                })()}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Cost Price */}
                                <div style={{ marginBottom: 20 }}>
                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#212529', marginBottom: 8 }}>Cost Price</div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        {/* Min */}
                                        <div style={{
                                            display: 'flex', alignItems: 'center',
                                            border: '1px solid #212529', borderRadius: 8,
                                            overflow: 'hidden', flex: 1, height: 38,
                                        }}>
                                            <span style={{
                                                padding: '0 10px', fontSize: 14, color: '#212529',
                                                background: '#FFF', borderRight: '1px solid #212529',
                                                height: '100%', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap',
                                            }}>SGD</span>
                                            <input
                                                type="text"
                                                placeholder="Min"
                                                value={costMinFocused ? tempCostMin : formatCostDisplay(tempCostMin)}
                                                onFocus={() => setCostMinFocused(true)}
                                                onBlur={() => {
                                                    setCostMinFocused(false);
                                                    const min = parseFloat(tempCostMin);
                                                    const max = parseFloat(tempCostMax);
                                                    if (tempCostMin !== '' && tempCostMax !== '' && min > max) {
                                                        setTempCostMin(tempCostMax);
                                                        setTempCostMax(tempCostMin);
                                                    }
                                                }}
                                                onChange={e => setTempCostMin(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'))}
                                                style={{
                                                    flex: 1, border: 'none', outline: 'none',
                                                    padding: '0 8px', fontSize: 13,
                                                    fontFamily: 'Montserrat', background: 'transparent',
                                                    color: "#212529"
                                                }}
                                            />
                                        </div>
                                        <span style={{ color: '#212529', fontSize: 14 }}>-</span>
                                        {/* Max */}
                                        <div style={{
                                            display: 'flex', alignItems: 'center',
                                            border: '1px solid #212529', borderRadius: 8,
                                            overflow: 'hidden', flex: 1, height: 38,
                                        }}>
                                            <span style={{
                                                padding: '0 10px', fontSize: 14, color: '#212529',
                                                background: '#FFF', borderRight: '1px solid #212529',
                                                height: '100%', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap',
                                            }}>SGD</span>
                                            <input
                                                type="text"
                                                placeholder="Max"
                                                value={costMaxFocused ? tempCostMax : formatCostDisplay(tempCostMax)}
                                                onFocus={() => setCostMaxFocused(true)}
                                                onBlur={() => {
                                                    setCostMaxFocused(false);
                                                    const min = parseFloat(tempCostMin);
                                                    const max = parseFloat(tempCostMax);
                                                    if (tempCostMin !== '' && tempCostMax !== '' && min > max) {
                                                        setTempCostMin(tempCostMax);
                                                        setTempCostMax(tempCostMin);
                                                    }
                                                }}
                                                onChange={e => setTempCostMax(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'))}
                                                style={{
                                                    flex: 1, border: 'none', outline: 'none',
                                                    padding: '0 8px', fontSize: 13,
                                                    fontFamily: 'Montserrat', background: 'transparent',
                                                    color: "#212529"
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <button
                                        type="button"
                                        onClick={handleFilterClear}
                                        style={{
                                            background: 'none', border: 'none', cursor: 'pointer',
                                            fontSize: 12, color: '#5A6A7D', fontFamily: 'Montserrat',
                                            fontWeight: 600, padding: '6px 0',
                                        }}
                                    >
                                        Clear
                                    </button>
                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <button
                                            type="button"
                                            onClick={() => setFilterOpen(false)}
                                            style={{
                                                height: 34, padding: '10px', borderRadius: 8,
                                                border: '1px solid #212529', background: '#fff',
                                                cursor: 'pointer', fontSize: 12, fontFamily: 'Montserrat',
                                                fontWeight: 600, color: '#212529',
                                                minWidth: "100px", justifyContent: 'center', alignItems: 'center', display: 'flex',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleFilterConfirm}
                                            style={{
                                                height: 34, padding: '10px', borderRadius: 8,
                                                border: '1px solid #212529', background: '#212529',
                                                cursor: 'pointer', fontSize: 12, fontFamily: 'Montserrat',
                                                fontWeight: 600, color: '#fff',
                                                minWidth: "100px", justifyContent: 'center', alignItems: 'center', display: 'flex',
                                            }}
                                        >
                                            Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ── Table ── */}
                <style>{`
                    .lsi-table .lsi-sticky-col {
                        position: sticky !important;
                        right: 0;
                        z-index: 2;
                    }
                    .lsi-table thead th {
                        position: sticky;
                        top: 0;
                        background: #E9ECEF;
                        z-index: 3;
                    }
                    .lsi-table thead .lsi-sticky-col {
                        background: #E9ECEF;
                        z-index: 6;
                    }
                    .lsi-table thead .lsi-select-col {
                        position: sticky;
                        left: 0;
                        z-index: 6;
                        background: #E9ECEF;
                    }
                    .lsi-table thead .lsi-stock-col {
                        position: sticky;
                        left: 90px;
                        z-index: 7;
                        background: #E9ECEF;
                    }
                    .lsi-table tbody .lsi-select-col {
                        position: sticky;
                        left: 0;
                        z-index: 2;
                    }
                    .lsi-table tbody .lsi-stock-col {
                        position: sticky;
                        left: 90px;
                        z-index: 3;
                    }
                    .lsi-table tbody tr:nth-child(odd) .lsi-sticky-col,
                    .lsi-table tbody tr:nth-child(odd) .lsi-select-col,
                    .lsi-table tbody tr:nth-child(odd) .lsi-stock-col {
                        background: #fff;
                    }
                    .lsi-table tbody tr:nth-child(even) .lsi-sticky-col,
                    .lsi-table tbody tr:nth-child(even) .lsi-select-col,
                    .lsi-table tbody tr:nth-child(even) .lsi-stock-col {
                        background: #F8F9FA;
                    }
                    .lsi-table tbody td {
                        border-bottom: 1px solid #F0F0F0;
                    }

                    /* Column resize grip mark */
                    .lsi-table .col-resize-handle::after {
                        content: "";
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        height: 50%;
                        left: 3px;
                        width: 2px;
                        background: #DEE2E6;
                    }

                    /* Sticky-column edge shadows — only shown while there's
                       actually scrolled content hidden behind the sticky
                       column, and forced to overflow:visible so the shadow
                       can escape despite overflow:hidden used for text
                       truncation on the same cells. */
                    .lsi-table th.lsi-select-col,
                    .lsi-table td.lsi-select-col,
                    .lsi-table th.lsi-stock-col,
                    .lsi-table td.lsi-stock-col,
                    .lsi-table th.lsi-sticky-col,
                    .lsi-table td.lsi-sticky-col {
                        overflow: visible !important;
                    }
                    .lsi-table.is-scrolled-left th.lsi-stock-col::after,
                    .lsi-table.is-scrolled-left td.lsi-stock-col::after {
                        content: "";
                        position: absolute;
                        top: 0;
                        right: -8px;
                        width: 8px;
                        height: 100%;
                        pointer-events: none;
                        z-index: 1;
                        background: linear-gradient(to right, rgba(0,0,0,0.12), rgba(0,0,0,0));
                    }
                    .lsi-table.is-scrolled-right th.lsi-sticky-col::before,
                    .lsi-table.is-scrolled-right td.lsi-sticky-col::before {
                        content: "";
                        position: absolute;
                        left: -8px;
                        top: 0;
                        width: 8px;
                        height: 100%;
                        background: linear-gradient(to left, rgba(0,0,0,0.12), rgba(0,0,0,0));
                        pointer-events: none;
                        z-index: 1;
                    }
                `}</style>
                <div style={{ flex: 1, minHeight: 0, position: 'relative', padding: '0 24px 0 24px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ border: '1px solid #E9ECEF', borderRadius: '12px', boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)', overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                <div
                    style={{ overflowX: 'auto', overflowY: 'auto', flex: 1, minHeight: 0 }}
                    ref={lsiTableScrollRef}
                    onScroll={handleLsiTableScroll}
                >
                    {!hasQuery ? (
                        <EmptyState />
                    ) : (isFetching || isPending) ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '40vh', gap: 16, fontFamily: 'Montserrat',  width: '100%', minHeight: 'clamp(200px, 60vh, 480px)' }}>
                            <div style={{ width: 36, height: 36, border: '4px solid #f3f3f3', borderTop: '4px solid #FFEB00', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                            <span style={{ fontSize: 14, fontWeight: 600, color: '#212529' }}>Please wait, we are finding your results...</span>
                        </div>
                    ) : fetchError ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: 'clamp(200px, 60vh, 480px)', color: '#DC3545', fontSize: 14, fontFamily: 'Montserrat', boxSizing: 'border-box' }}>
                            {fetchError}
                        </div>
                    ) : filtered.length === 0 ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: 'clamp(200px, 60vh, 480px)', color: '#6C757D', fontSize: 14, fontFamily: 'Montserrat', boxSizing: 'border-box' }}>
                            No results found
                        </div>
                    ) : (
                        <table
                            className={`entities-table lsi-table${lsiScrolledLeft ? ' is-scrolled-left' : ''}${lsiScrolledRight ? ' is-scrolled-right' : ''}`}
                            style={{
                                borderCollapse: 'separate',
                                borderSpacing: 0,
                                fontFamily: 'Montserrat', fontSize: 13,
                                tableLayout: 'fixed',
                                width: '100%',
                                minWidth: 1090,
                            }}>
                            <thead style={{ height: "45px", padding: '10px'}}>
                                <tr style={{ background: '#E9ECEF', borderBottom: '1px solid #E9ECEF', color: "#212529", fontSize: 12, fontWeight: 700, lineHeight: 'normal' }}>
                                    <th className="lsi-select-col" style={{ padding: '0 25px', width: 90 }}>
                                        <span>Select</span>
                                    </th>
                                    {[
                                        { label: 'Stock',              field: 'name',        colKey: 'stock',  minWidth: 150, thClass: 'lsi-stock-col' },
                                        { label: 'IMEI/Barcode',       field: 'serialNo' },
                                        { label: 'Branch',             field: 'branch' },
                                        { label: 'Cost Price',         field: 'costPrice',   showInfo: true },
                                        { label: 'In Stock Qty',       field: 'sellableQty' },
                                        { label: 'Last Stock-in Time', field: 'lastStock' },
                                    ].map(({ label, field, colKey, minWidth, thClass, showInfo }) => (
                                        <th key={field} className={thClass || ''} onClick={() => handleSort(field)} style={{ cursor: 'pointer', whiteSpace: 'nowrap', width: lsiColWidths[colKey || field], padding: '10px 10px 10px 10px' }}>
                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                                                {label}
                                                {showInfo && (
                                                    <span onClick={e => e.stopPropagation()}>
                                                        <Tooltip
                                                            title="Cost Price"
                                                            body="The cost price is the amount paid to acquire this stock instance."
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                <g clipPath="url(#clip0_7628_14874_hdr)">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82"/>
                                                                    <path d="M5.58122 4.11768L4.14997 4.29705L4.09872 4.53455L4.37997 4.58643C4.56372 4.63018 4.59997 4.69643 4.55997 4.87955L4.09872 7.04705C3.97747 7.60768 4.16435 7.87143 4.60372 7.87143C4.94435 7.87143 5.33997 7.71393 5.51935 7.49768L5.57434 7.23768C5.44934 7.34768 5.26684 7.39143 5.1456 7.39143C4.97372 7.39143 4.91122 7.2708 4.9556 7.0583L5.58122 4.11768Z" fill="#5E6E82"/>
                                                                    <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82"/>
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_7628_14874_hdr">
                                                                        <rect width="10" height="10" fill="white"/>
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </Tooltip>
                                                    </span>
                                                )}
                                                <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none"
                                                        style={{ opacity: sortField === field && sortOrder === 'asc' ? 1 : 0.35 }}>
                                                        <path d="M5.59334 3.11111C5.9566 3.11111 6.13824 2.72222 5.87588 2.48148L3.29263 0.111111C3.13118 -0.037037 2.86882 -0.037037 2.70736 0.111111L0.124122 2.48148C-0.138239 2.72222 0.0433953 3.11111 0.406664 3.11111H5.59334Z" fill="#6C757D"/>
                                                    </svg>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none"
                                                        style={{ opacity: sortField === field && sortOrder === 'desc' ? 1 : 0.35 }}>
                                                        <path d="M0.406664 0C0.0433955 0 -0.138239 0.388889 0.124122 0.629627L2.70736 3C2.86882 3.14815 3.13118 3.14815 3.29264 3L5.87588 0.629627C6.13824 0.388889 5.9566 0 5.59334 0H0.406664Z" fill="#6C757D"/>
                                                    </svg>
                                                </span>
                                            </span>
                                            <LsiColResizeHandle colKey={colKey || field} minWidth={minWidth || 80} />
                                            {thClass === 'lsi-stock-col' && stockEdgeCover}
                                        </th>
                                    ))}
                                    <th className="lsi-sticky-col" style={{ width: 120, textAlign: 'center' }}><span>Linked Qty</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {pageData.map((row, idx) => (
                                    <tr key={row.id} style={{
                                        background: idx % 2 === 1 ? '#F8F9FA' : '#fff',
                                    }}>
                                        {/* Checkbox */}
                                        <td
                                            onClick={(e) => e.stopPropagation()}
                                            className="lsi-select-col"
                                            style={{ padding: '0 25px' }}>
                                            <div
                                                onClick={() => {
                                                    const isChecked = (linkedQtys[row.id] || 0) > 0;
                                                    if (!isChecked) selectedItemsCacheRef.current[row.id] = row;
                                                    setLinkedQtys(prev => ({
                                                        ...prev,
                                                        [row.id]: isChecked ? 0 : (prev[row.id] || 1),
                                                    }));
                                                }}
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    aspectRatio: '1/1',
                                                    borderRadius: '4px',
                                                    border: (linkedQtys[row.id] || 0) > 0 ? '1.5px solid #212529' : '1px solid #212529',
                                                    background: (linkedQtys[row.id] || 0) > 0 ? '#FFEB00' : '#FFF',
                                                    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                {(linkedQtys[row.id] || 0) > 0 && (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M15 4.5L6.75 12.75L3 9" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                )}
                                            </div>
                                        </td>

                                        {/* Stock */}
                                        <td className="lsi-stock-col" style={{ padding: '10px 14px', overflow: 'hidden' }}>
                                            {stockEdgeCover}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                                                <img
                                                    src={row.image || noImage}
                                                    alt="product"
                                                    style={{ width: 32, height: 32, flexShrink: 0 }}
                                                />
                                                <div style={{ minWidth: 0, overflow: 'hidden' }}>
                                                    <div style={{ fontWeight: 400, color: '#212529', fontSize: 12, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{row.name}</div>
                                                    <div style={{ fontSize: 10, color: '#6C757D', marginTop: 2, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{row.variant}{row.model_number ? ` | ${row.model_number}` : ''}</div>
                                                    <div style={{ display: 'flex', gap: 4, marginTop: 4 }}>
                                                        <span style={{ background: '#FFEB00', borderRadius: 99, padding: '2px 5px', fontSize: 8, fontWeight: 600, color: '#212529', border: '1px solid #FFEB00' }}>
                                                            {row.condition}
                                                        </span>
                                                        <span style={{ background: '#FFEB00', borderRadius: 99, padding: '2px 5px', fontSize: 8, fontWeight: 600, color: '#212529', border: '1px solid #FFEB00' }}>
                                                            {row.grade}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Serial No */}
                                        <td style={{ padding: '10px', color: '#1F1F1F', fontSize: 12, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                            {row.serialNo}
                                        </td>

                                        {/* Branch */}
                                        <td style={{ padding: '10px', color: '#212529', fontSize: 12, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                            {row.branch}
                                        </td>

                                        {/* Cost Price */}
                                        <td style={{ padding: '10px', color: '#212529', fontSize: 12, overflow: 'hidden' }}>
                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                                {row.currency} {row.costPrice.toLocaleString('en-SG', { minimumFractionDigits: 2 })}
                                            </span>
                                        </td>

                                        {/* Sellable Qty */}
                                        <td style={{ padding: '10px', color: '#212529', fontSize: 12, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                            {typeof row.sellableQty === 'number'
                                                ? row.sellableQty.toLocaleString()
                                                : row.sellableQty}
                                        </td>

                                        {/* Last Stock */}
                                        <td style={{ padding: '10px', color: '#212529',fontSize: 12, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                            {row.lastStock}
                                        </td>

                                        {/* Linked Qty — sticky right */}
                                        <td className="lsi-sticky-col" style={{ padding: '10px' }}>
                                            <LinkedQtyInput
                                                value={linkedQtys[row.id] ?? 0}
                                                max={row.sellableQty}
                                                selected={(linkedQtys[row.id] || 0) > 0}
                                                onChange={val => setLinkedQtys(prev => ({ ...prev, [row.id]: val }))}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                    
                </div>
                {hasQuery && totalCount > 0 && filtered.length > 0 && (
                    <div style={{
                        padding: '12px 24px',
                        borderTop: '1px solid #E9ECEF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 12,
                        flexShrink: 0,
                        flexWrap: 'wrap',
                        background: '#fff',
                    }}>
                        <span style={{ fontSize: 13, color: '#6C757D' }}>
                            {`${(safePage - 1) * PAGE_SIZE + 1} - ${Math.min(safePage * PAGE_SIZE, totalCount)} of ${totalCount}`}
                        </span>
                        <InlinePagination
                            currentPage={safePage}
                            totalPages={totalPages}
                            onPageChange={(p) => setCurrentPage(p)}
                        />
                    </div>
                )}
                </div>
                </div>
                {/* ── Pagination ── */}

                {/* ── Footer ── */}
                <div style={{
                    padding: '14px 24px',
                    // borderTop: '1px solid #E9ECEF',
                    display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
                    gap: 12, flexShrink: 0,
                }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: 8,
                        border: '1px solid #212529', borderRadius: 8,
                        padding: '0 12px', height: 38,
                        fontSize: 13, fontFamily: 'Montserrat', fontWeight: 600, color: '#212529',
                    }}>
                        {(() => {
                            const count = Object.values(linkedQtys).filter(q => q > 0).length;
                            return (
                                <>
                                    <span>{count} Selected</span>
                                    {count > 0 && (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setLinkedQtys({});
                                                selectedItemsCacheRef.current = {};
                                            }}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    )}
                                </>
                            );
                        })()}
                    </div>
                    <button
                        type="button"
                        onClick={handleCancel}
                        style={{
                            height: 38, padding: '0 24px', borderRadius: 8,
                            border: '1px solid #212529', background: '#fff',
                            cursor: 'pointer', fontSize: 13, fontFamily: 'Montserrat',
                            fontWeight: 600, color: '#212529',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        style={{
                            height: 38, padding: '0 24px', borderRadius: 8,
                            border: 'none', background: '#212529',
                            cursor: 'pointer', fontSize: 13, fontFamily: 'Montserrat',
                            fontWeight: 600, color: '#fff',
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </>
    );
}

// ── Inline Pagination (mirrors the existing Pagination component pattern) ─────
function InlinePagination({ currentPage, totalPages, onPageChange }) {
    const [hoverLeft, setHoverLeft] = React.useState(false);
    const [hoverRight, setHoverRight] = React.useState(false);
    const JUMP = 5;

    if (totalPages <= 1) return null;

    const createPages = () => {
        let pages = [];
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
            return pages;
        }
        const start = Math.max(2, currentPage - 2);
        const end = Math.min(totalPages - 1, currentPage + 2);
        pages.push(1);
        if (start > 2) pages.push('left-ellipsis');
        for (let i = start; i <= end; i++) pages.push(i);
        if (end < totalPages - 1) pages.push('right-ellipsis');
        pages.push(totalPages);
        return pages;
    };

    const pages = createPages();

    const handleClick = (page) => {
        if (typeof page === 'number' && page !== currentPage) onPageChange(page);
    };

    const handleJump = (direction) => {
        if (direction === 'left') onPageChange(Math.max(1, currentPage - JUMP));
        else onPageChange(Math.min(totalPages, currentPage + JUMP));
    };

    return (
        <>
            <div className="lsi-pagination">
                <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                    <ChevronLeft size={18} />
                </button>

                {pages.map((page, index) => {
                    if (page === 'left-ellipsis') {
                        return (
                            <span
                                key={`left-${index}`}
                                className="lsi-ellipsis"
                                onMouseEnter={() => setHoverLeft(true)}
                                onMouseLeave={() => setHoverLeft(false)}
                                onClick={() => handleJump('left')}
                            >
                                {hoverLeft ? '<<' : '...'}
                            </span>
                        );
                    }
                    if (page === 'right-ellipsis') {
                        return (
                            <span
                                key={`right-${index}`}
                                className="lsi-ellipsis"
                                onMouseEnter={() => setHoverRight(true)}
                                onMouseLeave={() => setHoverRight(false)}
                                onClick={() => handleJump('right')}
                            >
                                {hoverRight ? '>>' : '...'}
                            </span>
                        );
                    }
                    return (
                        <button
                            key={page}
                            className={page === currentPage ? 'active' : ''}
                            onClick={() => handleClick(page)}
                        >
                            {page}
                        </button>
                    );
                })}

                <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    <ChevronRight size={18} />
                </button>
            </div>

            <style>{`
                .lsi-pagination {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 4px;
                    font-family: 'Montserrat', sans-serif;
                }
                .lsi-pagination button {
                    background: none;
                    border: none;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1;
                    cursor: pointer;
                    border-radius: 6px;
                    color: #212529;
                    padding: 6px 10px;
                    transition: all 0.2s ease;
                }
                .lsi-pagination button:hover:not(:disabled) {
                    background-color: #f2f2f2;
                }
                .lsi-pagination button.active {
                    background-color: #ffeb00;
                    font-weight: bold;
                }
                .lsi-pagination button:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }
                .lsi-ellipsis {
                    cursor: pointer;
                    color: #6c757d;
                    font-weight: bold;
                    font-size: 14px;
                    user-select: none;
                    padding: 4px 8px;
                    border-radius: 6px;
                    transition: all 0.2s ease;
                }
                .lsi-ellipsis:hover {
                    background-color: #f2f2f2;
                }
            `}</style>
        </>
    );
}
